import "phoenix_html"
import renderReactElements from "./util/renderReactElements"
import jquery from "jquery"
window.$ = jquery
window.jQuery = jquery
import { configure } from "mobx"
configure({ enforceActions: "never" })

import "./components/*.(t|j)sx"
import "./components/wizard"

import CardForm from "./third_party/CardForm"
import setupAffirmPaymentMessage from "./third_party/setupAffirmPaymentMessage"
import setupAffirmPaymentForm from "./third_party/setupAffirmPaymentForm"
import setupIntentForm from "./third_party/setupIntentForm"
import oneTimePaymentIntentForm from "./third_party/oneTimePaymentIntentForm"
import paymentProcessingElement from "./third_party/paymentProcessingElement"
import FormPhoneInput from "./legacy_components/FormPhoneInput"
import BulkCreditRecipientForm from "./legacy_components/BulkCreditRecipientForm"
import { ParticipationPaymentBreakdownFormInputs } from "./legacy_components/ParticipationPaymentBreakdownFormInputs"
import AdminPaymentSourceInputs from "./legacy_components/admin/AdminPaymentSourceInputs"
import InfoTooltip from "./legacy_components/shared/InfoTooltip"
import { addressFormToggles } from "./addresses"
import dateFormatter from "./dateFormatter"
import ListEditor from "./legacy_components/ListEditor"
import Alpine from "alpinejs"
import Clipboard from "@ryangjchandler/alpine-clipboard"
import "./element-toggle.js"
import "./bulk-credit/new/toggle-recipients-count-input.js"
import "./third_party/quill"

import disable from "./disable"
import disableLinkOnClick from "./disableLinkOnClick.js"
import autosubmit from "./autosubmit"
import apiNotices from "./apiNotices"

CardForm()

setupAffirmPaymentMessage()
setupAffirmPaymentForm()

setupIntentForm()
oneTimePaymentIntentForm()
paymentProcessingElement()
renderReactElements(InfoTooltip, "react-info-tooltip")
renderReactElements(FormPhoneInput, "form-phone-input")
renderReactElements(BulkCreditRecipientForm, "react-bulk-credit-recipient-form")
renderReactElements(ParticipationPaymentBreakdownFormInputs, "react-participation-payment-breakdown-inputs")
renderReactElements(AdminPaymentSourceInputs, "react-admin-payment-source-inputs")
renderReactElements(ListEditor, "react-list-editor")

disable()
disableLinkOnClick()
autosubmit()
apiNotices()
addressFormToggles()
dateFormatter()

import loadSvelteComponents from "./loadSvelteComponents"
import { webifySvelte } from "./util/webify"

loadSvelteComponents({
  AdjustmentForm: require("./components/AdjustmentForm.svelte"),
  TripQuestionnaireForm: require("./components/TripQuestionnaireForm.svelte"),
  CancellationForm: require("./components/CancellationForm.svelte"),
  RefundForm: require("./components/RefundForm.svelte"),
  StaffPermissionEditor: require("./components/StaffPermissionEditor.svelte"),
  MilestoneEditor: require("./components/MilestoneEditor.svelte"),
  TripPackagesList: require("./components/TripPackagesList.svelte"),
  TripQuestionsList: require("./components/TripQuestionsList.svelte"),
})

webifySvelte("gc-notice", require("./components/Notice.svelte"))
webifySvelte("gc-hamburger-button", require("./components/HamburgerButton.svelte"))
webifySvelte("trip-registrations-editor", require("./components/TripRegistrationsEditor.svelte"))

Alpine.plugin(Clipboard)
window.Alpine = Alpine
Alpine.start()
